{
  "accountScreen": {
    "downloadCta": "下载已签署文件",
    "helpDescription": "给我们发邮件：<underline>{{email}}</underline>",
    "helpTitle": "需要帮助或有疑问？",
    "loggedInWith": "已通过 {{method}} 登录",
    "title": "账号",
    "usernameLoginMethod": "用户名"
  },
  "addHouseholdMemberScreen": {
    "addAnother": "添加另一位",
    "addingMemberDescription": "我们想了解您的所有家庭成员。",
    "addingMemberTitle": "向我们介绍他们",
    "age": "年龄",
    "coverageCheck": {
      "dateOfBirth": "出生日期（选填）",
      "description": "可选填，有助于我们了解其已有保障。",
      "medicaidId": "Medicaid ID（选填）",
      "medicaidIdPlaceholder": "输入 Medicaid ID",
      "ssn": "社会安全号码 SSN（选填）",
      "ssnPlaceholder": "XXX-XX-XXXX",
      "title": "协助我们查看他们的保障"
    },
    "duplicateDialog": {
      "cancel": "不是，返回",
      "checkError": "我们无法核对您的家庭成员列表。请重试。",
      "confirm": "是的，是另一个人",
      "description": "您已经添加了 <bold>{{name}}</bold>。现在要添加的是另一个人吗？",
      "descriptionWithDetails": "您已经添加了 <bold>{{name}}</bold>（{{details}}）。现在要添加的是另一个人吗？",
      "reminder": "已添加的成员无需重复添加。",
      "title": "这是另一位家庭成员吗？"
    },
    "enterDateOfBirth": "改为输入出生日期",
    "enterRelationship": "输入关系",
    "firstName": "名字",
    "formSubmission": {
      "error": "我们无法添加该家庭成员。请重试。",
      "success": "已成功添加 {{firstName}}"
    },
    "lastName": "姓氏",
    "livingWithMe": "与我同住",
    "relationshipToMe": "与我的关系",
    "sameMailingAddress": "邮寄地址相同",
    "updateFormSubmission": {
      "success": "已成功更新 {{firstName}}"
    },
    "validations": {
      "ageOrDateOfBirthRequired": "请输入年龄范围或出生日期。",
      "futureDateOfBirth": "请输入今天或今天之前的出生日期。",
      "invalidDateOfBirth": "请输入有效的出生日期（月/日/年）。",
      "selectAnOption": "请选择一个选项。",
      "specifyRelationship": "请描述此人与您的关系。"
    }
  },
  "appFooter": {
    "partnershipLabel": "合作伙伴："
  },
  "appHeader": {
    "toggleThemeTooltip": "主题切换仅用于测试暗色/亮色模式。仅在本地和开发环境显示。"
  },
  "appMenu": {
    "account": "账号",
    "household": "家庭",
    "language": "语言",
    "logout": "退出登录"
  },
  "applicantDocuments": {
    "alsoCompleted": "此文件同时完成了{{section}}。",
    "alsoCompletedResidenceForMembers": "此文件也为居住在同一地址的家庭成员完成了{{section}}",
    "deleteDialog": {
      "description": "您确定要删除此文件吗？此操作无法撤销。",
      "title": "删除文件"
    },
    "deleteToast": {
      "error": "我们无法删除该文件。请重试。",
      "success": "文件已成功删除"
    },
    "immigrationIncomplete": {
      "description": "您仍需上传 USCIS 身份证件、移民文件与批准函或 I-20，才能完成{{section}}。",
      "dismiss": "知道了",
      "title": "还需要一份文件"
    },
    "optional": "选填",
    "progress": "已完成 {{applicableCount}} 中的 {{completeCount}}",
    "selectDocumentType": "选择文件类型",
    "ssn": {
      "cardOption": "或上传您的社会安全卡",
      "label": "社会安全号码 (SSN)",
      "save": "保存",
      "saveError": "我们无法保存该号码。请重试。",
      "saved": "社会安全号码已保存"
    },
    "supportedFiles": "支持的文件类型：PDF, JPG, PNG",
    "upload": {
      "failed": "无法上传该文件。请重试。",
      "failedDescription": "我们无法读取此文件。请将其删除并重新上传。",
      "uploading": "上传中..."
    },
    "uploadOne": "请上传<bold>至少一份：</bold>"
  },
  "applicationAddressScreen": {
    "description": "请核对并确认所有家庭成员的居住地址和邮寄地址。",
    "homeAddress": "居住地址",
    "isHomeless": "无固定住所",
    "mailingAddress": "邮寄地址",
    "needsHomeAddress": "<italic>需要居住地址</italic>",
    "needsMailingAddress": "<italic>需要邮寄地址</italic>",
    "noMailingAddress": "无邮寄地址",
    "sameHomeAddress": "相同的居住地址",
    "sameMailingAddress": "相同的邮寄地址",
    "title": "地址信息",
    "updateHouseholdAddressesDialog": {
      "addressTypeHome": "居住地址",
      "addressTypeHomeAndMailing": "居住和邮寄地址",
      "addressTypeMailing": "邮寄地址",
      "description_one": "{{householdName}} 和 {{count}} 位其他成员目前共用您的{{addressType}}。您是否也想更新他们的地址？",
      "description_other": "{{householdName}} 和 {{count}} 位其他成员目前共用您的{{addressType}}。您是否也想更新他们的地址？",
      "description_zero": "{{householdName}} 目前共用您的{{addressType}}。您是否也想更新他们的地址？",
      "onlyUpdateMine": "不，只更新我的",
      "title": "更新家庭成员地址",
      "updateMembers_one": "更新 {{count}} 名成员",
      "updateMembers_other": "更新 {{count}} 名成员"
    },
    "you": "{{name}}（您）"
  },
  "applicationChildCaregiverStatusScreen": {
    "description": "孩子必须与该家庭成员<bold>同住半年以上</bold>，且该家庭成员必须<bold>负担其一半以上</bold>的<bold>年度开销</bold>（包括食物、住房、学费和医疗费）。这包括非血缘关系的孩子。",
    "title": "以下家庭成员是否与 19 岁以下的孩子同住并负责照顾他们？"
  },
  "applicationCitizenshipStatusScreen": {
    "description": "<bold>{{householdMembersNames}}</bold> 都是美国公民吗？",
    "hintDescription": "如果您选择<bold>不是</bold>，请不要担心。根据移民身份，还有其他项目方案可供选择。",
    "noDescription": "部分或全部人员不是美国公民",
    "title": "申请资格",
    "yesDescription": "名单上的所有人都是美国公民"
  },
  "applicationConfirmationScreen": {
    "brokerDeclined": {
      "description": "选择“是的，联系我”，即可获得帮助，让您继续看原来的医生，并在同一处为家人投保。",
      "summaryWithMedicaid": "我们会审核您的 Medicaid 申请，如有需要会与您联系。您仍需要一位持牌保险代理人来完成 {{programs}} 的注册。",
      "summaryWithoutMedicaid": "我们已收到您提交的内容。您仍需要一位持牌保险代理人来完成 {{programs}} 的注册。",
      "title": "您选择了不联系持牌保险代理人。确定吗？"
    },
    "continueButton": "继续",
    "description": "我们的团队会审核您的申请，如有需要会与您联系。一切确认无误后，我们会将其发送给您选择的项目。",
    "title": "我们已收到您的申请！"
  },
  "applicationCoverageStatusScreen": {
    "description": "<bold>{{householdMembersNames}}</bold> 是否拥有医疗保险或医疗保障？请包括即将生效的保障。",
    "noDescription": "目前都没有保障",
    "pleaseSpecify": "请说明",
    "title": "保障状态",
    "whatType": "哪种类型的保障？",
    "who": "谁拥有保障？",
    "yesDescription": "有人拥有保障"
  },
  "applicationDateOfBirthScreen": {
    "description": "请添加并确认所有家庭成员的信息",
    "success": "所有出生日期已保存",
    "title": "出生日期"
  },
  "applicationDocuments": {
    "description": "我们将使用这些文件核实您申请中的信息。您可以立即上传文件，或稍后再回来完成。",
    "title": "上传文件"
  },
  "applicationExpensesScreen": {
    "addAnotherExpense": "添加另一项支出",
    "addExpense": "添加支出",
    "description": "为每位家庭成员添加可扣除费用和医疗支出。",
    "expenseTypes": {
      "ALIMONY_PAID": "支付的赡养费",
      "CHILDCARE": "育儿费",
      "IRA_CONTRIBUTIONS": "IRA 个人退休账户存款",
      "MEDICAL_EXPENSES": "医疗支出",
      "MOVING_EXPENSES": "搬家费",
      "NONE": "无",
      "OTHER": "其他",
      "STUDENT_LOANS": "学生贷款",
      "TUITION_FEES": "学费"
    },
    "memberDialog": {
      "alertDescriptions": {
        "MEDICAL_EXPENSES": "稍后我们需要您上传此项支出的证明，请准备好相关文件。这可能包括医疗账单、医疗机构或药房的收据。",
        "OTHER": "稍后我们需要您上传此项支出的证明，请准备好相关文件。",
        "STUDENT_LOANS": "稍后我们需要您上传此项支出的证明，请准备好相关文件。这可能包括学生贷款账单或学校的资助信。"
      },
      "medicalExpenses3MonthsHelpNeededStatus": "您在过去 3 个月内是否有需要协助支付的医疗支出？",
      "title": "选择支出类型"
    },
    "monthlyExpense": "{{monthlyExpense}} / 月",
    "progress": "进度：已完成 {{total}} 中的 {{progress}}",
    "title": "家庭支出"
  },
  "applicationFlow": {
    "amountPerMonth": "每月金额"
  },
  "applicationForm": {
    "applyingToCounter": "正在为 {{householdMembersCount}} 人申请 {{programsCount}} 个项目",
    "continueButton": "继续处理申请",
    "greatNews": "好消息！",
    "letsCreateApplications": "让我们为每个人创建申请吧。",
    "mayBeEligible": "<bold>{{names}}</bold> 可能符合资格",
    "mayBeEligibleFor": "{{memberNames}} 可能符合 <bold>{{brand}}</bold> 的资格",
    "notEligible": "目前不符合资格",
    "programConflictDialog": {
      "description": "申请{{newProgram}}将会取消{{memberNames}}的{{currentPrograms}}申请。{{memberNames}}不能同时申请两个项目。提交后，我们会确保{{memberNames}}进入正确的项目。",
      "description_members": "申请{{newProgram}}将会取消{{memberNames}}的{{currentPrograms}}申请。{{memberNames}}不能同时申请两个项目。提交后，我们会确保{{memberNames}}都进入正确的项目。",
      "description_self": "申请{{newProgram}}将会取消您的{{currentPrograms}}申请。您不能同时申请两个项目。提交后，我们会确保您进入正确的项目。",
      "keepButton": "保留{{currentPrograms}}",
      "multipleDescription": "申请{{newProgram}}将会取消{{memberNames}}的{{currentPrograms}}申请。{{memberNames}}不能同时申请这些项目。提交后，我们会确保{{memberNames}}进入正确的项目。",
      "multipleDescription_members": "申请{{newProgram}}将会取消{{memberNames}}的{{currentPrograms}}申请。{{memberNames}}不能同时申请这些项目。提交后，我们会确保{{memberNames}}都进入正确的项目。",
      "multipleDescription_self": "申请{{newProgram}}将会取消您的{{currentPrograms}}申请。您不能同时申请这些项目。提交后，我们会确保您进入正确的项目。",
      "recommendMedicaidDescription": "{{memberNames}}不能同时申请两个项目。Medicaid 是免费的，{{memberNames}}符合资格。提交后，我们会确保{{memberNames}}进入正确的项目。",
      "recommendMedicaidDescription_members": "{{memberNames}}不能同时申请两个项目。Medicaid 是免费的，{{memberNames}}都符合资格。提交后，我们会确保{{memberNames}}都进入正确的项目。",
      "recommendMedicaidDescription_self": "您不能同时申请两个项目。Medicaid 是免费的，而且您符合资格。提交后，我们会确保您进入正确的项目。",
      "recommendMedicaidTitle": "我们建议您申请 Medicaid",
      "switchButton": "改为{{newProgram}}",
      "title": "您只能申请一个项目"
    },
    "programsFound": "我们为所有 {{householdMembersCount}} 位家庭成员找到了 {{programsCount}} 个符合条件的项目。",
    "recentDuplicateDialog": {
      "continueAnyway": "仍然继续",
      "description": "您最近为 {{memberNames}} 提交过一份 <bold>{{applicationType}}</bold> 申请。只有在情况发生变化时，您才应再次提交申请。",
      "multipleDescription": "您最近为 {{memberNames}} 提交过 <bold>{{applicationTypes}}</bold> 申请。只有在情况发生变化时，您才应再次提交申请。",
      "title": "您最近提交过一份申请"
    },
    "startButton": "开始申请"
  },
  "applicationMaritalStatusScreen": {
    "description": "我们已根据您的家庭关系设定了婚姻状况。请查看并在需要时更新。",
    "needsMaritalStatus": "需要婚姻状况",
    "title": "当前婚姻状况"
  },
  "applicationOtherStatusesScreen": {
    "conditions": {
      "americanIndianOrAlaskaNative": "美国印第安人或阿拉斯加原住民",
      "needsHelpDailyActivities": "日常生活需要帮助",
      "studentFullTime18to20": "全日制学生（18 - 20 岁）",
      "veteranOrMilitaryMember": "退伍军人或现役军人"
    },
    "description": "请选择适用于家庭成员的任何情况。",
    "errors": {
      "unableToUpdateHouseholdMembers": "我们无法保存这些更改。请重试。"
    },
    "title": "其他情况"
  },
  "applicationSection": {
    "applications": "申请",
    "beginYourApplicationCompact": "15 分钟内即可完成申请",
    "beginYourApplicationProcess": "开始申请，15 分钟内即可获得保障",
    "continueQuickApply": "继续快速申请",
    "continueYourApplicationCompact": "继续您的申请",
    "continueYourApplicationProcess": "继续申请，15 分钟内即可获得保障",
    "newQuickApply": "新建快速申请",
    "quickApply": "快速申请"
  },
  "applicationSubmitScreen": {
    "description": "您已完成所有步骤。准备好后，请在下方提交。",
    "hintMessage": "提交后将无法更改，请确保所有信息准确无误。",
    "partialFailure": "您的某些保险申请可能尚未提交。请在申请列表中查看。",
    "submitButton": "提交申请",
    "success": "申请提交成功。",
    "title": "全部完成！"
  },
  "applicationTaxInformationScreen": {
    "description": "根据您分享的家庭信息，我们认为这反映了每个人的报税情况。请查看并在需要时更新。",
    "errors": {
      "unableToUpdateRelationship": "我们无法更新该关系。请重试。"
    },
    "memberCard": {
      "dependentOf": "受抚养于：{{name}}",
      "dependents": "受抚养人：{{name}}",
      "memberDialog": {
        "description": "如果需要，请查看并更新此人的税务详情。",
        "saveAndReturn": "保存并返回",
        "taxClaimedAsDependentStatus": "是否有人会将此人申报为受抚养人？",
        "taxDependentsClaimedStatus": "此人是否会申报任何受抚养人？",
        "taxFilingStatus": "报税状态",
        "title": "税务信息 – {{name}}",
        "who": "是谁？"
      }
    },
    "needsTaxInformation": "需要税务信息",
    "success": "税务信息更新成功",
    "title": "税务信息"
  },
  "applicationWorkAndIncomeScreen": {
    "addAnotherIncome": "添加另一项收入",
    "addIncome": "添加收入",
    "description": "为每位家庭成员添加工作和收入信息。",
    "incomeTypes": {
      "ALIMONY": "赡养费",
      "EMPLOYED": "受雇",
      "NONE": "无",
      "OTHER": "其他",
      "PENSION": "退休金",
      "PROPERTY_RENTAL_INCOME": "房产租金收入",
      "RETIREMENT_INCOME": "退休收入",
      "SELF_EMPLOYED": "自雇/个体经营",
      "SSA": "社会安全福利 (SSA)",
      "SSDI": "残疾保险福利 (SSDI)",
      "UNEMPLOYED": "失业",
      "WORKERS_COMPENSATION": "工伤赔偿"
    },
    "memberDialog": {
      "alertDescriptions": {
        "EMPLOYED": "稍后我们需要您上传此项收入的证明，请准备好相关文件。这可能包括工资单或 W-2 表单。",
        "OTHER": "稍后我们需要您上传此项收入的证明，请准备好相关文件。这可能包括补助信或福利声明。",
        "SELF_EMPLOYED": "稍后我们需要您上传此项收入的证明，请准备好相关文件。这可能包括发票或 1099 表单。",
        "UNEMPLOYED": "稍后我们需要您上传此项收入的证明，请准备好相关文件。这可能包括补助信或福利声明。"
      },
      "employerName": "雇主名称",
      "enterName": "输入姓名",
      "enterTypeOfWork": "输入工作类型",
      "grossMonthlyIncome": "每月税前总收入",
      "payFrequency": "发薪频率",
      "selfEmploymentNetMonthlyIncome": "扣除开销后的预计每月净收入",
      "title": "选择收入类型",
      "typeOfWork": "工作类型",
      "unemploymentCompensationStatus": "您是否领取失业救济金？",
      "workWeekHours": "每周工作时长"
    },
    "monthlyIncome": "{{monthlyIncome}} / 月",
    "title": "工作与收入"
  },
  "applicationsListScreen": {
    "applicationDate": "YYYY年MM月DD日 [于] A h:mm",
    "inProgress": "处理中",
    "noApplications": "您目前没有任何申请。",
    "submitted": "已提交",
    "title": "{{applicationType}} 申请"
  },
  "authScreen": {
    "appleSignInFailed": "我们无法使用 Apple 为您登录。请重试或使用其他登录方式。",
    "checkYourEmail": "查收您的邮件",
    "checkYourSpam": "没收到？请检查垃圾邮件文件夹，或几分钟后重试。",
    "continueWithApple": "通过 Apple 继续",
    "continueWithGoogle": "通过 Google 继续",
    "dataSecured": "您的数据在我们这里很安全。符合 HIPAA 和 SOC 2 标准。",
    "emailInput": "电子邮箱地址",
    "googleSignInFailed": "我们无法使用 Google 为您登录。请重试或使用其他登录方式。",
    "identifierInput": "电子邮箱或用户名",
    "invalidIdentifier": "请输入有效的电子邮箱或用户名。",
    "subtitle": "输入电子邮箱或用户名以继续。",
    "title": "登入或建立账号",
    "weSentALink": "我们已向 <bold>{{email}}</bold> 发送了一个安全链接。请点击链接继续。",
    "youAgree": "继续操作即表示您同意我们的<underline><colorEmphasis>服务条款</colorEmphasis></underline>和<privacyLink><colorEmphasis>隐私政策</colorEmphasis></privacyLink>。"
  },
  "brokerConsent": {
    "noButton": "不用了，谢谢",
    "recommendedBadge": "推荐",
    "yesButton": "是的，联系我"
  },
  "brokerConsentScreen": {
    "continueWithMedicaidOnlyButton": "仅继续 Medicaid",
    "continueWithoutAgentButton": "不用代理人，继续",
    "declineCard": {
      "applyLink": "申请 {{program}}",
      "fallbackWithMedicaid": "您仍可以在这里继续您的 Medicaid 申请。Pointcare 无需代理人即可处理您的 Medicaid 申请。",
      "fallbackWithoutMedicaid": "您仍可以在这里继续您的申请。现在完成申请，意味着当您的保险需求发生变化时，Pointcare 可以为您提供支持。",
      "selfEnrollmentWarning": "没有代理人，您需要自行注册 {{programs}}。",
      "title": "选择“是的，联系我”，充分利用 Pointcare"
    },
    "subtitle": "到了注册的时候我们会为您牵线，并且只分享帮助您所需的信息。",
    "subtitleWithIndividual": "到了注册的时候我们会为您牵线，并且只分享帮助您所需的信息。如果您正在申请 Medicare，这位代理人将是 {{brokerName}}。",
    "subtitleWithIndividualLicense": "到了注册的时候我们会为您牵线，并且只分享帮助您所需的信息。如果您正在申请 Medicare，这位代理人将是 {{brokerName}}（执照号：{{licenseNumber}}）。",
    "subtitleWithOrganization": "到了注册的时候我们会为您牵线，并且只分享帮助您所需的信息。如果您正在申请 Medicare，这位代理人将来自 {{brokerName}}。",
    "subtitleWithOrganizationLicense": "到了注册的时候我们会为您牵线，并且只分享帮助您所需的信息。如果您正在申请 Medicare，这位代理人将来自 {{brokerName}}（执照号：{{licenseNumber}}）。",
    "title": "联系持牌保险代理人，了解 Medicare 和/或 ACA 医疗保险 Marketplace 方案并获得完成注册的帮助"
  },
  "camera": {
    "grantPermission": "授予权限",
    "permissionDescription": "如需拍摄文件照片，请在手机设置中允许访问摄像头。",
    "permissionRequired": "我们需要访问您的摄像头。",
    "photoCount": "已拍摄 {{count}} 张照片",
    "tapToCapture": "点击按钮拍照"
  },
  "cesSurvey": {
    "feedbackLabel": "是什么让您觉得困难？",
    "feedbackPlaceholder": "请告诉我们更多",
    "optionalLabel": "可选",
    "questions": {
      "consentFormSigned": "理解您所签署的内容有多容易？",
      "householdMemberAdded": "添加家庭成员有多容易？",
      "incomeAdded": "添加收入信息有多容易？"
    },
    "scoreEasy": "容易",
    "scoreHard": "困难",
    "scoreOk": "一般",
    "scoreVeryEasy": "非常容易",
    "scoreVeryHard": "非常困难",
    "thanksDescription": "您的反馈将帮助我们改进。",
    "thanksTitle": "谢谢！"
  },
  "consentDocuments": {
    "addSignature": "添加签名",
    "description": "请在下方签名，以便我们为您提供支持。",
    "documentTitle": "信息披露授权书 (PDF)",
    "grant1": "监测您的保障情况并及早发现问题",
    "grant2": "代您处理申请 — 无遗漏、无混乱",
    "grant3": "提交申请和续期并跟进，让您不再错过截止日期",
    "grant4": "出于营销目的通过普通或自动电话、语音消息和短信与您联系",
    "grantHealthPlanSelection": "将您选择的健康保险计划和医生（如有）应用于您的保险",
    "grantSubtitle": "具体包括：",
    "healthPlanAvailabilityError": "我们无法查询可用的健康保险计划。请在签署前重试。",
    "signatureCountsAsInitials": "在适用的情况下，您的签名也将视为您在表格上的姓名首字母。",
    "title": "授权保障管理",
    "viewDocument": "查看文件"
  },
  "coverage": {
    "code": "代码：",
    "coverageStatus": "保障状态",
    "inProgress": "处理中",
    "isCovered": "{{name}} 已获得 {{programs}} 的保障。",
    "lastCheck": "最近检查",
    "lastCheckDateFormat": "YYYY/MM/DD",
    "lastCheckWithDate": "最近检查 {{date}}",
    "noMatchingRecord": "我们无法找到您的保险覆盖范围。请检查您输入的信息并重试。",
    "planName": "计划名称",
    "primaryCareProvider": "初级保健医生",
    "programCoverage": "{{program}} 保障",
    "programListing": {
      "medicaid": "<bold>Medicaid</bold>",
      "medicare": "<bold>Medicare</bold>",
      "medicareAndMedicaid": "<bold>Medicare</bold> 和 <bold>Medicaid</bold>"
    },
    "serviceTypes": "服务类型",
    "status": {
      "checking": "正在检查保障情况...",
      "checkingShort": "检查中...",
      "covered": "有保障",
      "coveredBy": "由 {{ programs }} 提供保障",
      "notCovered": "无保障",
      "unknown": "保障情况未知",
      "unknownShort": "未知"
    },
    "updateProfileInformation": "更新个人信息"
  },
  "createPasswordScreen": {
    "passwordInputLabel": "密码",
    "passwordInputPlaceholder": "设置密码",
    "passwordRequirement": "请使用至少 10 个字符。",
    "subtitle": "为您的新账号设置一个强密码以继续。",
    "title": "设置密码"
  },
  "createUsernameAccountScreen": {
    "passwordInputLabel": "密码",
    "passwordInputPlaceholder": "请设置密码",
    "subtitle": "为您的新账号设置一个强密码以继续。",
    "title": "设置密码"
  },
  "dateOfBirthInput": {
    "dayPlaceholder": "日",
    "monthPlaceholder": "月",
    "yearPlaceholder": "年"
  },
  "eligibilityHouseholdIncomeScreen": {
    "description1": "对于大多数收入来源，请使用税前总收入。如果您是自雇人士，请使用扣除业务开支后的净收入。",
    "description2": "这包括所有家庭成员的预计收入：",
    "hideBreakdown": "隐藏明细",
    "householdIncomeCalculator": {
      "annualDescription": "输入每人的预计年收入来计算总额",
      "biWeeklyDescription": "输入每人的预计每两周收入来计算总额",
      "monthlyDescription": "输入每人的预计月收入来计算总额",
      "period": {
        "annual": "年",
        "biWeekly": "2周",
        "monthly": "月"
      },
      "title": "计算您的收入",
      "totalIncomeTitle": "家庭总收入：",
      "totalIncomeValue": "{{total}} / {{period}}",
      "useRange": "使用 {{label}}"
    },
    "incomePeriod": {
      "annual": "年度",
      "biWeekly": "每两周",
      "monthly": "每月"
    },
    "incomeRange": {
      "0-1800": "$0 - $1,800",
      "0-3700": "$0 - $3,700",
      "0-44400": "$0 - $44,400",
      "1600-2600": "$1,600 - $2,600",
      "2500-3000": "$2,500 - $3,000",
      "3000-3300": "$3,000 - $3,300",
      "3300+": "$3,300 或以上",
      "3500-5600": "$3,500 - $5,600",
      "43000-67000": "$43,000 - $67,000",
      "5500-6500": "$5,500 - $6,500",
      "6500-7000": "$6,500 - $7,000",
      "66000-78000": "$66,000 - $78,000",
      "7000+": "$7,000 或以上",
      "78000-83000": "$78,000 - $83,000",
      "83000+": "$83,000 或以上"
    },
    "showBreakdown": "需要帮助计算？显示明细",
    "title": "您的家庭大致收入是多少？",
    "updateError": "我们无法保存您的收入。请重试。"
  },
  "eligibilityHouseholdMembers": {
    "title": "您的家庭",
    "you": "您"
  },
  "eligibilityLiveAndCareScreen": {
    "description": "他们必须与您<bold>同住半年以上</bold>，且您必须<bold>负担其一半以上</bold>的<bold>年度开销</bold>（食物、住房、学费和医疗费）。这包括非血缘关系的孩子。",
    "formDescription": "添加与您同住并由您提供经济支持的 19 岁以下的孩子、继子女、孙子女或寄养儿童。",
    "formTitle": "告诉我们关于您抚养的孩子",
    "supporterDescription": "他们必须与 {{supporterFirstName}} <bold>同住半年以上</bold>，且 {{supporterFirstName}} 必须<bold>负担其一半以上</bold>的<bold>年度开销</bold>（食物、住房、学费和医疗费）。这包括非血缘关系的孩子。",
    "supporterFormDescription": "添加与 {{supporterFirstName}} 同住的所有 19 岁以下的孩子。",
    "supporterFormTitle": "告诉我们关于 {{supporterFirstName}} 的孩子",
    "supporterTitle": "{{supporterFirstName}} 是否与 19 岁以下的孩子同住并负责照顾他们？",
    "title": "您是否与 19 岁以下的孩子同住并负责照顾他们？"
  },
  "eligibilityMaritalStatusScreen": {
    "description": "这有助于我们了解您的家庭情况，并确定您可能符合哪些项目的资格。",
    "formDescription": "我们需要关于您配偶或伴侣的一些基本信息，以帮助确定您的资格。",
    "formTitle": "告诉我们关于您的配偶或伴侣",
    "supporterFormDescription": "我们需要关于 {{supporterFirstName}} 配偶或伴侣的一些基本信息。",
    "supporterFormTitle": "告诉我们关于 {{supporterFirstName}} 的配偶或伴侣",
    "supporterTitle": "{{supporterFirstName}} 的婚姻状况是什么？",
    "title": "您的婚姻状况是什么？"
  },
  "eligibilityParentGuardianStudentScreen": {
    "description": "您必须<bold>负担其一半以上</bold>的<bold>年度开销</bold>（食物、住房、学费和医疗费）。",
    "formDescription": "添加所有 18-21 岁、您是其父母或法定监护人并提供经济支持的全日制学生。",
    "formTitle": "告诉我们关于您支助的学生",
    "supporterDescription": "{{supporterFirstName}} 必须<bold>负担其一半以上</bold>的<bold>年度开销</bold>（食物、住房、学费和医疗费）。",
    "supporterFormDescription": "添加所有 18-21 岁、{{supporterFirstName}} 是其父母或法定监护人并提供经济支持的全日制学生。",
    "supporterFormTitle": "告诉我们关于 {{supporterFirstName}} 支助的学生",
    "supporterTitle": "{{supporterFirstName}} 是否是其提供经济支持的 18-21 岁全日制学生的父母或法定监护人？",
    "title": "您是否是其提供经济支持的 18-21 岁全日制学生的父母或法定监护人？"
  },
  "eligibilitySomeoneSupportsYou": {
    "description": "这包括食物、住房、学费和医疗费。",
    "errors": {
      "updateFailed": "我们无法保存这些更改。请重试。"
    },
    "formDescription": "添加为您提供一半以上年度经济支持的个人，例如父母、监护人或亲属。",
    "formTitle": "向我们介绍支持您的人",
    "options": {
      "disabled": "是的，我是残障人士，并且全年与支持我的人同住。",
      "fullTimeStudent": "是的，我是全日制学生，我的父母或法定监护人支持我。",
      "personSupportsMe": "是的，我一年中超过半年的时间与支持我的人同住。",
      "relativeSupportsMe": "是的，我一年中超过半年的时间与支持我的亲戚同住。"
    },
    "title": "是否有人为您提供一半以上的年度经济支持？"
  },
  "eligibilitySpecialConditionsScreen": {
    "addDetails": "添加详情",
    "conditions": {
      "blind": "有人失明",
      "breastCancer": "有人患有乳腺癌",
      "cervicalCancer": "有人患有宫颈癌",
      "disabled": "有人是残疾人士 (SSDI)",
      "fosterCare": "有人在 18 岁时处于寄养状态",
      "pregnant": "有人怀孕"
    },
    "description": "请选择适用于家庭成员的任何情况。",
    "errors": {
      "allUpdatesFailed": "我们无法保存这些更改。请重试。"
    },
    "pregnancyDetails": {
      "estimatedDueDate": "预计预产期",
      "numberOfBabies": "预计婴儿数量",
      "title": "怀孕详情"
    },
    "pregnancyInfo": {
      "babiesWithCount_one": "{{count}} 个宝宝 • 预产期 {{date}}",
      "babiesWithCount_other": "{{count}} 个宝宝 • 预产期 {{date}}"
    },
    "title": "家庭特殊情况"
  },
  "eligibilitySupportDisabledIndividualScreen": {
    "description": "这可以是任何人——孩子、兄弟姐妹、祖父母或非血缘关系的亲属——任何年龄均可。您必须<bold>负担其一半以上</bold>的<bold>年度开销</bold>（食物、住房、学费和医疗费）。",
    "formDescription": "添加全年与您同住且由您提供经济支持的所有残疾人士。这可以包括孩子、兄弟姐妹、祖父母或非血缘关系的亲属。",
    "formTitle": "告诉我们关于您资助的残疾人士",
    "supporterDescription": "这可以是任何人——孩子、兄弟姐妹、祖父母或非血缘关系的亲属——任何年龄均可。{{supporterFirstName}} 必须<bold>负担其一半以上</bold>的<bold>年度开销</bold>（食物、住房、学费和医疗费）。",
    "supporterFormDescription": "添加全年与 {{supporterFirstName}} 同住且由其提供经济支持的所有残疾人士。这可以包括孩子、兄弟姐妹、祖父母或非血缘关系的亲属。",
    "supporterFormTitle": "告诉我们关于 {{supporterFirstName}} 资助的残疾人士",
    "supporterTitle": "{{supporterFirstName}} 是否经济支持一名与其全年同住的残疾人士？",
    "title": "您是否经济支持一名与您全年同住的残疾人士？"
  },
  "eligibilitySupportOtherRelativesScreen": {
    "description": "他们必须与您<bold>同住半年以上</bold>，且您必须<bold>负担其一半以上</bold>的<bold>年度开销</bold>（食物、住房、学费和医疗费）。这包括直系和旁系亲属、继亲和姻亲。",
    "formDescription": "添加与您同住并由您提供经济支持的所有直系或旁系亲属、继亲或姻亲。",
    "formTitle": "告诉我们关于您支助的亲属",
    "supporterDescription": "他们必须与 {{supporterFirstName}} <bold>同住半年以上</bold>，且 {{supporterFirstName}} 必须<bold>负担其一半以上</bold>的<bold>年度开销</bold>（食物、住房、学费和医疗费）。这包括直系和旁系亲属、继亲和姻亲。",
    "supporterFormDescription": "添加一年中大部分时间与 {{supporterFirstName}} 同住并由其提供经济支持的所有直系或旁系亲属、继亲或姻亲。",
    "supporterFormTitle": "告诉我们关于 {{supporterFirstName}} 所支助的亲属",
    "supporterTitle": "{{supporterFirstName}} 是否经济支持与其同住的任何其他亲属？",
    "title": "您是否经济支持与您同住的任何其他亲属？"
  },
  "homeScreen": {
    "addMember": "添加成员",
    "applicationSubmittedCard_multiple": "您已为 {{memberNames}} 提交 <programs /> 申请。我们会进行审核，如有需要会与您联系。",
    "applicationSubmittedCard_single": "您已为 {{memberNames}} 提交 <programs /> 申请。我们会进行审核，如有需要会与您联系。",
    "applicationSubmittedCard_singleMarketplace": "您已为 {{memberNames}} 提交 <programs /> 申请。我们会进行审核，如有需要会与您联系。",
    "checkEligibility": "检查家庭资格",
    "checkEligibilityCompact": "检查资格",
    "devScenarioActive": "模拟场景已启用 — 仪表板正在显示测试数据。",
    "devScenarioReset": "重置",
    "eligibilityCardCompactNotStarted": "看看您可能符合哪些项目的条件",
    "eligibilityCardCompactStarted": "继续，看看您可能符合哪些项目的条件",
    "eligibilityCardNotStarted": "开始快速的一步步检查，看看您的家庭可能符合哪些项目的条件",
    "eligibilityCardStarted": "继续您的资格检查，看看您的家庭可能符合哪些项目的条件",
    "household": "家庭",
    "logout": "退出登录",
    "nextSteps": "后续步骤",
    "recheckEligibility": "重新检查资格"
  },
  "householdMemberScreen": {
    "applicantDocuments": "申请人文件",
    "checkCoverage": "检查保障情况",
    "deleteButton": "从家庭中移除 {{memberFullName}}",
    "deleteDialog": {
      "description": "这将永久从您的家庭中移除 {{memberFullName}}。他们的所有信息和上传的文件都将被删除且无法恢复。\n此操作无法撤销。",
      "title": "移除家庭成员"
    },
    "deleteToast": {
      "error": "我们无法删除该家庭成员。请重试。",
      "success": "家庭成员已成功删除"
    },
    "profileInformation": "资料信息"
  },
  "landingScreen": {
    "goToAuth": "前往登录界面"
  },
  "languageSelectorModal": {
    "title": "选择语言"
  },
  "languages": {
    "arabicDescription": "阿拉伯语",
    "chineseSimplifiedDescription": "简体中文",
    "englishDescription": "英语",
    "haitianCreoleDescription": "海地克里奥尔语",
    "russianDescription": "俄语",
    "spanishDescription": "西班牙语",
    "tagalogDescription": "塔加路语",
    "vietnameseDescription": "越南语"
  },
  "memberFormSubmission": {
    "error": "我们无法保存这些更改。请重试。",
    "success": "家庭成员信息已成功更新"
  },
  "mfaPhoneScreen": {
    "phoneNumberLabel": "电话号码",
    "phoneNumberPlaceholder": "(555) 000-0000",
    "sendVerificationCodeText": "我们将向您发送验证码。",
    "subtitle": "我们将使用此信息来保护您的账号安全。",
    "title": "您的电话号码是什么？"
  },
  "mfaVerifyScreen": {
    "getNewCode": "获取新验证码",
    "subtitle": "请输入我们发送至\n<bold>{{phoneNumber}}</bold> 的 6 位验证码",
    "title": "我们已向您发送验证码",
    "verificationCodeLabel": "验证码"
  },
  "notFound": {
    "cta": "返回首页",
    "description": "您查找的页面已不存在。",
    "title": "未找到页面。"
  },
  "npsSurveyScreen": {
    "highFeedbackLabel": "您最喜欢 Pointcare 的哪一点？（选填）",
    "highFeedbackPlaceholder": "告诉我们让您印象深刻的地方",
    "lowFeedbackLabel": "我们可以在哪些方面做得更好？（选填）",
    "lowFeedbackPlaceholder": "告诉我们哪里出了问题...",
    "mediumFeedbackLabel": "怎样才能让您给 10 分？（选填）",
    "mediumFeedbackPlaceholder": "告诉我们怎样会更好...",
    "scaleHighLabel": "→ 非常可能",
    "scaleLowLabel": "→ 完全不可能",
    "submitButton": "提交反馈",
    "subtitle": "您的回答绝不会分享给您申请的项目。",
    "success": "反馈已成功提交。",
    "testimonialLabel": "我们可以在网站上分享您的反馈，帮助更多人找到保障吗？我们只会使用您的名字。",
    "title": "您有多大可能向朋友或家人推荐 Pointcare？"
  },
  "onboarding": {
    "benefits": {
      "description": "Pointcare 已帮助全美 180 万多名患者寻找并维持他们的医疗保障。",
      "firstItem": "只需 5 分钟即可了解谁符合资格",
      "firstItem_AGING_INTO_MEDICARE": "寻找合适的 Medicare 保障",
      "firstItem_AGING_INTO_MEDICARE_awareness": "随时了解时间表进度",
      "firstItem_LAPSE": "只需 5 分钟即可了解谁符合资格",
      "firstItem_QR_CODE": "只需 5 分钟即可了解谁符合资格",
      "firstItem_RECURRING_WORK_REQUIREMENT": "永不错过重要的截止日期",
      "firstItem_REDETERMINATION": "永不错过重要的截止日期",
      "firstItem_SELF_PAY_CONVERSION": "只需 5 分钟即可了解谁符合资格",
      "firstItem_SERVICE_INTRODUCTION_medicaid": "永不错过重要的截止日期",
      "firstItem_SERVICE_INTRODUCTION_medicare": "5 分钟内检查每个人的福利",
      "freeToUse": "免费帮助——无隐藏费用",
      "infoIsPrivate": "分享的任何信息均严格保密",
      "title": "{{clinicName}} 已与 Pointcare 合作，为您的家庭提供支持",
      "titleNoClinic": "Pointcare 在这里为您家提供支持"
    },
    "buttons": {
      "createMyProfile": "创建我的资料",
      "getStarted": "现在开始"
    },
    "concerns": {
      "description": "选择您最关心的选项——我们将告诉您我们能如何提供帮助。",
      "description_SERVICE_INTRODUCTION_medicare": "请选择最符合此保障情况的选项。",
      "title": "为您家人获得保障时，最让您感到困扰的是什么？",
      "title_SERVICE_INTRODUCTION_medicare": "您的家庭拥有哪种 Medicare 保障？"
    },
    "figuringOutWhenToRenew": {
      "option": "弄清楚何时续期",
      "subtext": "我们将跟踪每个人的续期日期，并在到期前提醒您。"
    },
    "figuringOutWhenToSubmitRequirements": {
      "option": "弄清楚何时提交材料",
      "subtext": "我们将跟踪每个人的材料提交日期，并在到期前提醒您。"
    },
    "imNotSure": {
      "option": "我不确定",
      "subtext": "我们会确保每个人的计划仍然适合他们。"
    },
    "intro": {
      "description": "很多人无需支付任何费用。其他人每月仅需支付 20-30 美元。我们将询问几个简单的问题，为大家寻找最佳选择。",
      "description_AGING_INTO_MEDICARE": "您现在可能收到了很多广告。作为您家人的医疗服务提供者，我们将帮助您找到合适的计划。",
      "description_AGING_INTO_MEDICARE_awareness": "您现在可能收到了很多广告。作为您家人的医疗服务提供者，我们将帮助您找到合适的计划。",
      "description_LAPSE": "十分之七的人可能重新符合免费或低成本保障的资格。无论是重新参加 Medicaid 还是寻找其他选择，我们都会全程提供帮助。",
      "description_QR_CODE": "很多人无需支付任何费用。其他人每月仅需支付 20-30 美元。我们将询问几个简单的问题，为大家寻找最佳选择。",
      "description_RECURRING_WORK_REQUIREMENT": "新法律要求提供收入证明。我们将检查受影响的人员是否符合要求或可以豁免，并据此为您提供支持。",
      "description_REDETERMINATION": "您需要确认或更新家庭信息以维持他们的保障。我们会全程提供帮助。",
      "description_SELF_PAY_CONVERSION": "很多人无需支付任何费用。其他人每月仅需支付 20-30 美元。我们将询问几个简单的问题，为大家寻找最佳选择。",
      "description_SERVICE_INTRODUCTION_medicaid": "我们将关注每个人的保障情况，协助续期，并免费引导您解决任何出现的问题。",
      "description_SERVICE_INTRODUCTION_medicare": "我们将帮助您了解每个人的保障内容，寻找额外福利，并确保您不会遗漏任何事项。",
      "title": "获得医疗保障并不难。您的家人可能符合<colorEmphasis>免费或低成本计划</colorEmphasis>的条件。",
      "title_AGING_INTO_MEDICARE": "您家里似乎有人符合 Medicare 资格已有 <colorEmphasis>{{count}} 个月</colorEmphasis>。我们在这里为您提供帮助。",
      "title_AGING_INTO_MEDICARE_awareness_one": "您家里似乎有人在 <colorEmphasis>{{monthsToTurning65}} 个月内</colorEmphasis>符合 Medicare 资格。我们在这里为您提供帮助。",
      "title_AGING_INTO_MEDICARE_awareness_other": "您家里似乎有人在 <colorEmphasis>{{monthsToTurning65}} 个月内</colorEmphasis>符合 Medicare 资格。我们在这里为您提供帮助。",
      "title_AGING_INTO_MEDICARE_one": "您家里似乎有人符合 Medicare 资格已有 <colorEmphasis>{{count}} 个月</colorEmphasis>。我们在这里为您提供帮助。",
      "title_AGING_INTO_MEDICARE_other": "您家里似乎有人符合 Medicare 资格已有 <colorEmphasis>{{count}} 个月</colorEmphasis>。我们在这里为您提供帮助。",
      "title_AGING_INTO_MEDICARE_zero": "您家里似乎有人<colorEmphasis>从本月起</colorEmphasis>符合 Medicare 资格。我们在这里为您提供帮助。",
      "title_LAPSE": "您家里似乎有人在 <colorEmphasis>{{lapseDate}}</colorEmphasis> 失去了 {{payerName}} 的保障。我们在这里帮助他们重新获得保障。",
      "title_QR_CODE": "您的家人可能符合<colorEmphasis>免费或低成本医疗保障</colorEmphasis>的条件。让我们来看看。",
      "title_RECURRING_WORK_REQUIREMENT_one": "您家里似乎有人在 <colorEmphasis>{{count}} 个月内</colorEmphasis>需要完成 {{payerName}} 的工作证明。让我们帮他们维持保障。",
      "title_RECURRING_WORK_REQUIREMENT_other": "您家里似乎有人在 <colorEmphasis>{{count}} 个月内</colorEmphasis>需要完成 {{payerName}} 的工作证明。让我们帮他们维持保障。",
      "title_RECURRING_WORK_REQUIREMENT_zero": "您家里似乎有人<colorEmphasis>本月</colorEmphasis>需要完成 {{payerName}} 的工作证明。让我们帮他们维持保障。",
      "title_REDETERMINATION_one": "您家里似乎有人在 <colorEmphasis>{{count}} 个月内</colorEmphasis>需要进行 {{payerName}} 续期。让我们帮他们维持保障。",
      "title_REDETERMINATION_other": "您家里似乎有人在 <colorEmphasis>{{count}} 个月内</colorEmphasis>需要进行 {{payerName}} 续期。让我们帮他们维持保障。",
      "title_REDETERMINATION_zero": "您家里似乎有人<colorEmphasis>本月</colorEmphasis>需要进行 {{payerName}} 续期。让我们帮他们维持保障。",
      "title_SERVICE_INTRODUCTION_medicaid": "我们在这里帮助您的家庭<colorEmphasis>维持 {{payerName}} 的保障。</colorEmphasis>",
      "title_SERVICE_INTRODUCTION_medicare": "您的家庭是否<colorEmphasis>充分利用了 {{payerName}} 的福利？</colorEmphasis>我们在这里为您提供帮助。"
    },
    "keepingMyCurrentDoctors": {
      "option": "保留目前的医生",
      "subtext": "我们将帮助寻找包含您家人已经在看的医生的计划。"
    },
    "meetingRequirements": {
      "option": "符合要求",
      "subtext": "我们将在符合并提交工作要求方面为大家提供支持。"
    },
    "missingEnrolmentDeadline": {
      "option": "错过注册截止日期",
      "subtext": "我们将确保您知道何时注册，以避免任何逾期罚款。"
    },
    "nextSteps": {
      "step1Description": "向我们介绍您的情况",
      "step1Duration": "2 分钟",
      "step1Title": "建立个人档案",
      "step2Description": "您家人符合条件的保障",
      "step2Description_AGING_INTO_MEDICARE": "查看当前状态",
      "step2Description_AGING_INTO_MEDICARE_awareness": "查看当前状态",
      "step2Description_LAPSE": "您家人符合条件的保障",
      "step2Description_QR_CODE": "您家人符合条件的保障",
      "step2Description_RECURRING_WORK_REQUIREMENT": "我们将检查受影响的人是否符合豁免或按计划进行",
      "step2Description_RECURRING_WORK_REQUIREMENT_awareness": "我们将检查受影响的人是否符合豁免或按计划进行",
      "step2Description_REDETERMINATION": "我们的呼叫团队将与您联系",
      "step2Description_REDETERMINATION_awareness": "包括基本联系信息",
      "step2Description_SELF_PAY_CONVERSION": "您家人符合条件的保障",
      "step2Description_SERVICE_INTRODUCTION_medicaid": "查看当前状态",
      "step2Description_SERVICE_INTRODUCTION_medicare": "查看当前状态",
      "step2Description_SERVICE_INTRODUCTION_medicare_partABorD": "查看当前状态",
      "step2Duration": "5 分钟",
      "step2Duration_AGING_INTO_MEDICARE": "2 分钟",
      "step2Duration_AGING_INTO_MEDICARE_awareness": "2 分钟",
      "step2Duration_LAPSE": "5 分钟",
      "step2Duration_QR_CODE": "5 分钟",
      "step2Duration_RECURRING_WORK_REQUIREMENT": "5 分钟",
      "step2Duration_RECURRING_WORK_REQUIREMENT_awareness": "5 分钟",
      "step2Duration_REDETERMINATION": "2 分钟",
      "step2Duration_SELF_PAY_CONVERSION": "5 分钟",
      "step2Duration_SERVICE_INTRODUCTION_medicaid": "2 分钟",
      "step2Duration_SERVICE_INTRODUCTION_medicare": "2 分钟",
      "step2Duration_SERVICE_INTRODUCTION_medicare_partABorD": "2 分钟",
      "step2Title": "寻找您的选择",
      "step2Title_AGING_INTO_MEDICARE": "检查保障",
      "step2Title_AGING_INTO_MEDICARE_awareness": "检查保障",
      "step2Title_LAPSE": "寻找您的选择",
      "step2Title_QR_CODE": "寻找您的选择",
      "step2Title_RECURRING_WORK_REQUIREMENT": "检查要求",
      "step2Title_RECURRING_WORK_REQUIREMENT_awareness": "检查要求",
      "step2Title_REDETERMINATION": "请求续期支持",
      "step2Title_REDETERMINATION_awareness": "添加家庭信息",
      "step2Title_SELF_PAY_CONVERSION": "寻找您的选择",
      "step2Title_SERVICE_INTRODUCTION_medicaid": "检查保障",
      "step2Title_SERVICE_INTRODUCTION_medicare": "检查保障",
      "step2Title_SERVICE_INTRODUCTION_medicare_partABorD": "检查保障",
      "step3Description": "剩下的交给我们！",
      "step3Description_AGING_INTO_MEDICARE": "剩下的交给我们！",
      "step3Description_AGING_INTO_MEDICARE_awareness": "我们将让您随时了解最新情况并做好准备",
      "step3Description_LAPSE": "剩下的交给我们！",
      "step3Description_QR_CODE": "剩下的交给我们！",
      "step3Description_RECURRING_WORK_REQUIREMENT": "我们将引导您完成此过程",
      "step3Description_RECURRING_WORK_REQUIREMENT_awareness": "我们将让您了解最新情况并支持您的家庭达到要求",
      "step3Description_REDETERMINATION": "我们将引导您完成此过程",
      "step3Description_REDETERMINATION_awareness": "我们将让您随时了解最新情况并做好准备",
      "step3Description_SELF_PAY_CONVERSION": "剩下的交给我们！",
      "step3Description_SERVICE_INTRODUCTION_medicaid": "我们会提前提醒您",
      "step3Description_SERVICE_INTRODUCTION_medicare": "看看每个人的计划中包含了什么",
      "step3Description_SERVICE_INTRODUCTION_medicare_partABorD": "扩展福利",
      "step3Duration": "15 分钟",
      "step3Duration_SERVICE_INTRODUCTION_medicare": "1 分钟",
      "step3Title": "提交申请",
      "step3Title_AGING_INTO_MEDICARE": "提交 Medicare 申请",
      "step3Title_AGING_INTO_MEDICARE_awareness": "准备好加入 Medicare",
      "step3Title_LAPSE": "提交申请",
      "step3Title_QR_CODE": "提交申请",
      "step3Title_RECURRING_WORK_REQUIREMENT": "提交材料",
      "step3Title_RECURRING_WORK_REQUIREMENT_awareness": "提前完成材料提交",
      "step3Title_REDETERMINATION": "提交续期申请",
      "step3Title_REDETERMINATION_awareness": "提前完成续期",
      "step3Title_SELF_PAY_CONVERSION": "提交申请",
      "step3Title_SERVICE_INTRODUCTION_medicaid": "永不错过截止日期",
      "step3Title_SERVICE_INTRODUCTION_medicare": "查看您的福利",
      "step3Title_SERVICE_INTRODUCTION_medicare_partABorD": "探索 Medicare 选项",
      "title": "准备好为您的家人获得保障了吗？",
      "title_RECURRING_WORK_REQUIREMENT": "让我们为您和家人继续提供保障",
      "title_RECURRING_WORK_REQUIREMENT_awareness": "让我们为您和家人继续提供保障",
      "title_REDETERMINATION": "让我们为您和家人继续提供保障",
      "title_REDETERMINATION_awareness": "让我们为您和家人继续提供保障",
      "title_SERVICE_INTRODUCTION_medicaid": "让我们为您和家人继续提供保障",
      "title_SERVICE_INTRODUCTION_medicare": "让我们为您和家人继续提供保障",
      "title_SERVICE_INTRODUCTION_medicare_partABorD": "让我们为您和家人继续提供保障"
    },
    "notKnowingHowToGetCovered": {
      "option": "不知道如何获得保障",
      "subtext": "我们将引导您确切地了解如何让每个人获得保障。"
    },
    "notKnowingImCovered": {
      "option": "不知道谁有保障",
      "subtext": "我们可以检查每个人是否有保障，如果您没有，我们将帮您获得。",
      "subtext_RECURRING_WORK_REQUIREMENT": "我们将检查每个人的保障情况，并在您需要时帮您获得。",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "我们将检查每个人的保障情况，并在您需要时帮您获得。",
      "subtext_REDETERMINATION": "我们将检查每个人的保障情况，并在您需要时帮您获得。",
      "subtext_REDETERMINATION_awareness": "我们将检查每个人的保障情况，并在您需要时帮您获得。",
      "subtext_SERVICE_INTRODUCTION_medicaid": "我们将检查每个人的保障情况，并在您需要时帮您获得。"
    },
    "paperwork": {
      "option": "文书工作太多或太混乱",
      "subtext": "我们将为每个人处理所有文书工作——从参保到续期。",
      "subtext_SERVICE_INTRODUCTION": "我们代表您家人的医疗服务提供者，为大家的健康需求寻找最佳选择。"
    },
    "partAB": {
      "option": "Part A & B (Medicare)",
      "subtext": "我们将为每个人寻找最佳选择，无论是当前计划还是 Medicare Advantage (Part C)。"
    },
    "partABD": {
      "option": "Part A, B, & D (Medicare + 药物)",
      "subtext": "我们将为每个人寻找最佳选择，无论是当前计划还是 Medicare Advantage (Part C)。"
    },
    "partC": {
      "option": "Part C (Medicare Advantage)",
      "subtext": "我们会确保每个人的计划仍然适合他们。"
    },
    "payingForDoctor": {
      "option": "支付看病和药费",
      "subtext": "我们将帮助每个人寻找能降低看病和买药成本的保障。"
    },
    "somethingElse": {
      "option": "其他事宜",
      "subtext": "我们将帮助每个人获得保障并维持保障。",
      "subtext_AGING_INTO_MEDICARE": "我们将一步步引导您获得 Medicare。",
      "subtext_AGING_INTO_MEDICARE_awareness": "我们将一步步引导您获得 Medicare。",
      "subtext_RECURRING_WORK_REQUIREMENT": "我们将帮助每个人维持保障——不会有意外中断。",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "我们将帮助每个人维持保障——不会有意外中断。",
      "subtext_REDETERMINATION": "跳过混乱的文书工作。我们将帮助每个人维持保障。",
      "subtext_REDETERMINATION_awareness": "跳过混乱的文书工作。我们将帮助每个人维持保障。",
      "subtext_SERVICE_INTRODUCTION_medicaid": "跳过混乱的文书工作。我们将帮助每个人维持保障。",
      "subtext_SERVICE_INTRODUCTION_medicare": "我们会确保每个人的计划仍然适合他们。"
    },
    "submittingRenewals": {
      "option": "提交续期",
      "subtext": "我们将为每个人处理续期。只需回答几个简单问题即可。"
    },
    "tooManyMedicareAdsAndCalls": {
      "option": "Medicare 广告和电话太多",
      "subtext": "我们将帮您过滤干扰，找到合适的计划。"
    },
    "variants": {
      "improvedVerbiage": {
        "benefits": {
          "description": "Pointcare 已帮助 180 万多名患者寻找并维持他们的医疗保障。",
          "firstItem_LAPSE": "只需 5 分钟即可查看谁符合资格",
          "infoIsPrivate": "您的信息在我们这里很安全",
          "title": "{{clinicName}} 与 Pointcare 合作，为您的家庭提供帮助"
        },
        "concerns": {
          "description_LAPSE": "选择您最关心的事情，我们会告诉您我们能如何提供帮助。",
          "title_LAPSE": "为您的家人获得保障，最难的是什么？"
        },
        "intro": {
          "description_LAPSE": "大多数人可以重新获得免费或低成本保障的资格。我们会全程为您提供帮助。",
          "title_LAPSE": "您家里有人在 <colorEmphasis>{{lapseDate}}</colorEmphasis> 失去了 {{payerName}} 的保障。我们在这里帮助他们重新获得保障。"
        },
        "nextSteps": {
          "step2Description_LAPSE": "查看您的家人符合哪些保障资格"
        },
        "paperwork": {
          "option": "令人困惑的文书工作"
        }
      }
    }
  },
  "passwordScreen": {
    "forgotPassword": "忘记您的密码？",
    "passwordInputLabel": "密码",
    "passwordInputPlaceholder": "输入您的密码",
    "resetPasswordInstructions": "我们已向 <bold>{{email}}</bold> 发送了密码重置链接。打开它以创建新密码。",
    "subtitle": "请输入您的账户密码以继续。",
    "title": "输入密码",
    "usernameResetUnavailable": "用户名账号无法通过邮件重置密码。请致电我们，我们会协助您。"
  },
  "profileInformationScreen": {
    "addressComplement": "公寓、单元、楼层（选填）",
    "checkCoverage": "保障检查测试",
    "coverageStatus": "保障状态：{{status}}",
    "dateOfBirth": "出生日期",
    "email": "电子邮箱",
    "firstName": "名字",
    "homeAddress": "居住地址",
    "lastName": "姓氏",
    "mailingAddress": "邮寄地址",
    "mailingAddressComplement": "公寓、单元、大楼、信箱（选填）",
    "medicaidCaseNumber": "Medicaid 案件编号（选填）",
    "medicaidSubscriberId": "Medicaid 用户 ID（选填）",
    "noHomeAddress": "无固定居住地址",
    "noMailingAddress": "无邮寄地址",
    "phoneNumber": "电话号码",
    "socialSecurityNumber": "社会安全号码 (SSN)",
    "useDifferentMailingAddress": "使用不同的邮寄地址"
  },
  "recheckEligibilityScreen": {
    "button": "重新检查资格",
    "title": "在重新检查资格前，请确保您的家庭成员信息是最新的。"
  },
  "redeterminationScreen": {
    "addressInformation": "更新地址信息",
    "alreadyMailedForm": "已经寄回表格或计划很快寄回",
    "caseNumberDescription": "我们将使用您的案件编号更快地提交您的续期！\n\n请在您的续期表格或您所在州机构关于您承保范围的其他邮件中查找此编号。",
    "caseNumberDescription_PENDING_FORM": "我们将使用您的案件编号更快地提交您的续期！\n\n请在您所在州机构关于您承保范围的邮件中查找此编号。",
    "caseNumberLabel": "案件编号",
    "caseNumberPlaceholder": "输入案件编号",
    "caseNumberTitle": "添加您的案件编号（可选）",
    "description": "选择最符合的选项",
    "haventReceivedForm": "尚未收到表格",
    "receivedForm": "收到了表格，需要帮助填写",
    "returnToDashboard": "返回控制面板",
    "reviewAddress": "请核对并确认所有家庭成员的住址和邮寄地址。这样可确保续期表格寄送到正确的地址。",
    "successDescription": "您的续期已经处理妥当。如有任何变化，我们会联系您。",
    "successDescription_CALL_BACK": "我们的团队将在1-2个工作日内与您联系，以完成您的续期。",
    "successDescription_PENDING_FORM": "续期表格将寄送到存档的地址。请留意邮件、电子邮箱和短信。我们一定会在截止日期前跟进。",
    "successTitle": "一切就绪！",
    "successTitle_CALL_BACK": "我们会尽快致电给您。",
    "successTitle_PENDING_FORM": "一切就绪！",
    "title": "您家里有人需要在 {{date}} 前完成续期。"
  },
  "redeterminations": {
    "cardAggregated_CALL_BACK": "有 {{total}} 项 Medicaid 续期正在等待来电 — 截止日期为 {{dates}}。请留意您的电话。",
    "cardAggregated_NOT_STARTED": "有 {{total}} 项 Medicaid 续期待开始。",
    "cardAggregated_PENDING_FORM": "有 {{total}} 份 Medicaid 续期表格即将寄达。请留意邮件、电子邮件和短信。",
    "cardCompact_PENDING_FORM": "续期表格即将寄达 — 截止日期为 {{date}}",
    "card_CALL_BACK": "您家中有一项 Medicaid 续期正在等待来电 — 截止日期为 {{date}}。请留意您的电话。",
    "card_NOT_STARTED": "您家中有一项 Medicaid 续期，截止日期为 {{date}}。",
    "card_PENDING_FORM": "您家中有一份 Medicaid 续期表格即将寄达 — 截止日期为 {{date}}。请留意邮件、电子邮件和短信。",
    "due": "截止日期 {{date}}",
    "medicaidRenewals": "Medicaid 续期",
    "noRenewals": "暂无续期。",
    "startRenewal": "开始续期",
    "status": "请求回电",
    "status_CALL_BACK": "已请求回电",
    "status_COMPLETED": "已完成",
    "status_NOT_STARTED": "未开始",
    "status_PENDING_FORM": "等待表格",
    "title": "续期",
    "updateStatus": "更新状态"
  },
  "registrationCoverageScreen": {
    "description": "Pointcare 可以根据您下方提供的信息查询您当前的 Medicaid 保障情况。",
    "title": "让我们检查您的保障情况"
  },
  "registrationProfileScreen": {
    "description": "提供将用于申请的个人资料详情。"
  },
  "resetPasswordScreen": {
    "confirmPasswordInputLabel": "确认新密码",
    "confirmPasswordInputPlaceholder": "重新输入新密码",
    "invalidResetLink": "此密码重置链接无效或已过期。请重新申请。",
    "passwordInputLabel": "新密码",
    "passwordInputPlaceholder": "输入新密码",
    "subtitle": "请选择一个您以前未使用过的强密码。",
    "title": "创建新密码",
    "updatePasswordButton": "更新密码"
  },
  "sessionTimedOut": {
    "description": "为了您的安全，由于您长时间未操作，我们已将您退出登录。请重新登录以继续。",
    "loginAgain": "重新登录",
    "title": "您已退出登录"
  },
  "sessionTimeout": {
    "countdown": "剩余 {{time}}",
    "description": "由于长时间未操作，您的登录即将过期。您想保持登录状态吗？",
    "logOutNow": "现在退出",
    "secureSession": "安全会话",
    "stayLoggedIn": "维持登录",
    "title": "您还在吗？"
  },
  "signatureField": {
    "signaturePrompt": "请在此签名"
  },
  "someHouseholdMembersNotUpdated": "我们无法保存所有人的更改。请检查每位家庭成员以确保已保存。",
  "support": {
    "callUs": "致电我们",
    "callUsAt": "请拨打 <underline>{{phoneNumber}}</underline> 联系我们"
  },
  "workRequirements": {
    "cardActionCompact_START": "开始",
    "cardActionCompact_UPLOAD_DOCUMENTS": "上传",
    "cardAction_CONTINUE": "继续完成工作要求",
    "cardAction_START": "开始工作要求",
    "cardAction_UPLOAD_DOCUMENTS": "上传文件",
    "cardCompact": "Medicaid 工作要求截止日期为 {{date}}",
    "card_CONTINUE": "您家中有人需要完成 Medicaid 工作要求，截止日期为 {{date}}。请继续检查谁已按计划进行或可以豁免。",
    "card_START": "您家中有人需要完成 Medicaid 工作要求，截止日期为 {{date}}。请检查您是否按计划进行或可以豁免。",
    "card_UPLOAD_DOCUMENTS": "您家中有人需要完成 Medicaid 工作要求，截止日期为 {{date}}。请上传文件以按计划进行。",
    "caseNumbers": {
      "description": "我们将使用这些案件编号为您的家庭提交材料。",
      "descriptionSingle": "我们将使用此案件编号提交 {{name}} 的工作证明文件。",
      "hint": "请在您所在州机构关于您承保范围的邮件中查找这些编号。",
      "hintSingle": "请在州机构关于 {{name}} 承保范围的邮件中查找此编号。",
      "memberLabel": "{{name}}",
      "title": "添加您家庭的案件编号（可选）",
      "titleSingle": "添加 {{name}} 的案件编号（可选）"
    },
    "confirmation": {
      "completedDescription": "我们的团队会进行审核，如有需要会与您联系。",
      "completedTitle": "恭喜，您已完成<label>工作要求</label>",
      "description": "请记得在 {{date}} 续期前完成您的要求。",
      "title": "<label>工作要求</label>正在进行中",
      "uploadsHint": "开放更多月份后，您可以在控制面板中完成上传。"
    },
    "due": "截止日期 <bold>{{date}}</bold>",
    "exemptions": {
      "description": "请选择所有适用项",
      "groups": {
        "BENEFITS_AND_COVERAGE": "福利与保障",
        "CAREGIVING": "照护",
        "HEALTH_AND_RECOVERY": "健康与康复",
        "LIFE_SITUATIONS": "生活状况"
      },
      "options": {
        "CAREGIVER_OF_CHILD_13_OR_YOUNGER": "13 岁或以下儿童的父母或照护者",
        "CAREGIVER_OF_PERSON_WITH_DISABILITY": "残障人士的照护者",
        "FOSTER_YOUTH_UNDER_26": "26 岁以下的寄养青少年或曾经的寄养青少年",
        "INCARCERATED_OR_RELEASED_LAST_90_DAYS": "正在看守所或监狱服刑，或在过去 90 天内获释",
        "IN_DRUG_OR_ALCOHOL_TREATMENT": "正在参加戒毒或戒酒治疗项目",
        "MEDICALLY_FRAIL": "身体虚弱（医学认定）",
        "MEETING_SNAP_TANF_WORK_REQUIREMENTS": "已符合 SNAP/TANF 工作要求",
        "NOT_ENROLLED_OR_ELIGIBLE_FOR_MEDICARE": "未参加 Medicare，也不符合 Medicare 资格",
        "PREGNANT_OR_POSTPARTUM": "怀孕或处于产后期（12 个月或以内）",
        "TRIBAL_MEMBER": "联邦认可的美洲原住民部落成员",
        "VETERAN_100_PERCENT_DISABILITY": "残障评级为完全（100%）残障的退伍军人"
      },
      "title": "是否符合以下任何豁免情况？"
    },
    "hours": {
      "communityService": "社区服务",
      "description_completed": "请添加 {{name}} 在 {{month}} 已完成的时数。如果没有，请留空。",
      "description_expected": "请添加 {{name}} 在 {{month}} 预计的时数。如果没有，请留空。",
      "employment": "就业",
      "employmentHint": "请输入时数和每月工资。我们会将工资换算成时数，并按较高者计入要求。",
      "hoursPerMonth": "小时 / 月",
      "jobTraining": "职业培训",
      "payPerMonth": "$ / 月",
      "school": "上学 / 学徒",
      "title": "为 {{name}} 报告时数",
      "totalHours": "总时数",
      "totalOf": "<bold>{{total}}</bold> / {{required}}"
    },
    "income": {
      "description": "请选择所有适用的人；如果没有，请继续。",
      "everyone": "这里的所有人",
      "title": "谁每月收入 ${{amount}} 或以上？",
      "titleSingle": "{{name}} 每月收入是否达到 ${{amount}} 或以上？"
    },
    "medicaidWorkRequirements": "Medicaid 工作要求",
    "nextSteps": {
      "complete": "已完成 {{total}} 中的 {{completed}}",
      "description": "以下是每个人为维持保障需要提交的材料。",
      "needsMoreHours": "每月还需 {{hours}} 小时",
      "offrampDescription": "要维持医疗保障，每月必须完成 {{hours}} 小时的认可活动。这些活动可以包括就业、职业培训、上学、学徒和/或社区服务。",
      "opensOn": "{{date}} 开放",
      "proofOfExemption": "豁免证明",
      "proofOfWork": "工作证明（{{month}}）",
      "reasonHours": "已报告每月 {{hours}} 小时",
      "reasonIncome": "每月收入 ${{amount}} 或以上",
      "reportedOf": "已报告每月 {{required}} 小时中的 {{hours}} 小时",
      "status_EXEMPT": "豁免",
      "status_MEETS_REQUIREMENTS": "符合要求",
      "title": "<label>工作要求</label>后续步骤",
      "volunteerOpportunities": "志愿服务机会"
    },
    "noWorkRequirements": "您的家庭没有工作要求。",
    "progress_ACTION_NEEDED": "需要处理",
    "progress_COMPLETED": "已完成",
    "progress_UP_TO_DATE": "已是最新",
    "recheck": "重新检查工作要求",
    "sectionTitle": "工作要求",
    "whatAreDescription": "一项新的联邦法律要求部分参加 Medicaid 的成年人每月工作、参加职业培训、上学或做志愿服务 {{hours}} 小时。这仅适用于 {{minAge}} 至 {{maxAge}} 岁的成年人。",
    "who": {
      "checkAll": "检查所有家庭成员",
      "noEligibleMembers": "您的家庭中没有人年龄在 {{minAge}} 至 {{maxAge}} 岁之间，因此无需检查任何人。",
      "question": "<bold>您想检查谁？我们将查看他们是否按计划进行或可以豁免，并据此为您提供支持。</bold>",
      "title": "检查家庭的<label>工作要求</label>状态"
    }
  }
}
